<template>
  <section class="has-text-default mt-40 mx-20">
    <div class="level">
      <div class="level-left">
        <div class="level-item mr-20">
          <a @click="annuler">
            <b-icon icon="chevron-left" type="is-default"></b-icon>
            <span class="has-text-grid-1 has-text-weight-bold is-size-4 ml-10">
              {{$t('concurrent.titleParametrerConcurrent')}}
            </span>
          </a>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-button type="is-transparent" class="has-text-default"
            @click="annuler">
            {{$t('concurrent.btnAnnuler')}}
          </b-button>
        </div>
        <div class="level-item">
          <b-button
            type="is-primary"
            class="has-text-weight-bold ml-20"
            @click="creerConcurrent">
            {{  $t('concurrent.btnAjouter') }}
          </b-button>
        </div>
      </div>
    </div>

    <b-table
      :data="getConcurrentsSelected"
      class="mb-20">

      <b-table-column v-slot="props"
        field="url"
        :label="$t('concurrent.table.logo')"
        header-class="is-size-7 has-text-grid-1 pa-20 has-text-weight-bold"
        cell-class="is-size-7 has-text-default has-text-middle px-20">
        <upload-image
          v-model="props.row.urlLogo"
          :is-concurrent="true"/>
      </b-table-column>

      <b-table-column v-slot="props"
        field="" label=""
        header-class="is-size-7 has-text-grid-1 pa-20 has-text-weight-bold"
        cell-class="is-size-7 has-text-default has-text-middle">
        <a @click="dupliquerInfo(props.row.urlLogo, 'urlLogo', props.index)">
          <b-icon icon="chevron-double-down"
            size="is-medium"
            type="is-grid-1">
          </b-icon>
        </a>
      </b-table-column>

      <b-table-column v-slot="props"
        field="name"
        :label="$t('concurrent.table.nomCommercial')"
        header-class="is-size-7 has-text-grid-1 pa-20 has-text-weight-bold"
        cell-class="is-size-7 has-text-default has-text-middle px-20">
        <b-input v-model="props.row.name"></b-input>
      </b-table-column>

      <b-table-column v-slot="props"
        field="" label=""
        header-class="is-size-7 has-text-grid-1 pa-20 has-text-weight-bold"
        cell-class="is-size-7 has-text-default has-text-middle">
        <a @click="dupliquerInfo(props.row.name, 'name', props.index)">
          <b-icon icon="chevron-double-down"
            size="is-medium"
            type="is-grid-1">
          </b-icon>
        </a>
      </b-table-column>

      <b-table-column v-slot="props"
        field="adresse"
        :label="$t('concurrent.table.adresse')"
        header-class="is-size-7 has-text-grid-1 pa-20 has-text-weight-bold"
        cell-class="is-size-7 has-text-default has-text-middle px-20">
        <AutoCompleteAdresse
          @place_change="changeAdresse($event, props.row)"
          :libelle="props.row.adresse"/>
      </b-table-column>

      <b-table-column v-slot="props"
        field="" label=""
        header-class="is-size-7 has-text-grid-1 pa-20 has-text-weight-bold"
        cell-class="is-size-7 has-text-default has-text-middle">
        <a @click="dupliquerInfo(props.row, constantes.ADRESSE, props.index)">
          <b-icon icon="chevron-double-down"
            size="is-medium"
            type="is-grid-1">
          </b-icon>
        </a>
      </b-table-column>

      <b-table-column v-slot="props"
        field="secteurActiviteId"
        :label="$t('concurrent.table.secteurActivite')"
        header-class="is-size-7 has-text-grid-1 pa-20 has-text-weight-bold"
        cell-class="is-size-7 has-text-default has-text-middle px-20">
        <parametre-autocomplete
          v-model="props.row.secteurActiviteId"
          :target="constantes.PARAMETRES_KEYS.secteurActivite"
          :create="false"
        />
      </b-table-column>

      <b-table-column v-slot="props"
        field="" label=""
        header-class="is-size-7 has-text-grid-1 pa-20 has-text-weight-bold"
        cell-class="is-size-7 has-text-default has-text-middle">
        <a @click="dupliquerInfo(props.row, constantes.SECTEUR_ACTIVITE, props.index)">
          <b-icon icon="chevron-double-down"
            size="is-medium"
            type="is-grid-1">
          </b-icon>
        </a>
      </b-table-column>

      <b-table-column v-slot="props"
        field="marque"
        :label="$t('concurrent.table.marque')"
        header-class="is-size-7 has-text-grid-1 pa-20 has-text-weight-bold"
        cell-class="is-size-7 has-text-default has-text-middle px-20">
        <query-marque-tag-input v-model="props.row.tiersMarques" />
      </b-table-column>

      <b-table-column v-slot="props"
        field="" label=""
        header-class="is-size-7 has-text-grid-1 pa-20 has-text-weight-bold"
        cell-class="is-size-7 has-text-default has-text-middle pr-20">
        <a @click="dupliquerInfo(props.row.tiersMarques, 'tiersMarques', props.index)">
          <b-icon icon="chevron-double-down"
            size="is-medium"
            type="is-grid-1">
          </b-icon>
        </a>
      </b-table-column>

    </b-table>
  </section>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametrage-mutation-type';
import * as types from '@/store/creationRecommandation/pointDeVente-mutation-type';
import { addManyClients } from '@/api/clients/index';
import gestionErreur from '@/services/general/gestionErreur';
import { getImg } from '@/services/general/general';
import { genererConcurrents } from '@/services/client/genererTiers';
import generePJ from '@/services/piecesJointes/genererPiecesJointes';
import { insertPieceJointe } from '@/services/piecesJointes/savePiecesJointes';
import { getLogoFileFromDataURI } from '@/services/concurrent/concurrent';
import UploadImage from '@/components/general/uploadImage.vue';
import AutoCompleteAdresse from '@/components/general/autoCompleteAdresse.vue';
import QueryMarqueTagInput from '@/components/general/queryMarqueTagInput.vue';
import ParametreAutocomplete from '@/components/general/parametreAutocomplete.vue';

const User = createNamespacedHelpers('user');
const Societe = createNamespacedHelpers('societe');
const PointDeVente = createNamespacedHelpers('pointDeVente');
const Recommandation = createNamespacedHelpers('recommandations');

const ADRESSE = 'adresse';
const ENSEIGNE = 'enseigne';
const SECTEUR_ACTIVITE = 'secteurActivite';

export default {
  components: {
    UploadImage,
    QueryMarqueTagInput,
    AutoCompleteAdresse,
    ParametreAutocomplete,
  },
  data() {
    return {
      isLoadEnseigne: false,
      listeEnseigne: [],
      constantes: {
        ADRESSE,
        ENSEIGNE,
        PARAMETRES_KEYS,
        SECTEUR_ACTIVITE,
      }
    };
  },
  computed: {
    ...User.mapGetters({
      societeId: 'idSociete',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...PointDeVente.mapGetters({
      getRayon: 'rayon',
      getConcurrentsSelected: 'concurrentSelectionnes',
    }),
    ...Recommandation.mapGetters({
      pointDeVenteRecommandation: 'pointDeVente',
    }),
  },
  methods: {
    ...PointDeVente.mapMutations({
      setConcurrentSelectionnes: types.SET_CONCURRENT_SELECTIONNES,
      setLastRayon: types.SET_LAST_RAYON,
    }),
    annuler() {
      this.setConcurrentSelectionnes([]);
      this.$router.push({ name: 'recherche-concurrent' });
    },
    getImg(img) {
      return getImg(img);
    },
    changeAdresse(adress, concurrent) {
      concurrent.adressePostale = adress ? adress : null;
      concurrent.adresse = adress ? adress.libelle : '';
    },
    async addPiecesJointe(filesLogos) {
      const piecesJointes = await generePJ(
        filesLogos.map(pj => ({file: pj.file, placeType: 'Logo'})),
      );
      const req = piecesJointes.map((pj, index) => insertPieceJointe([pj], filesLogos[index].id, 'Client'));
      await Promise.all(req);
    },
    async creerConcurrent() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        const concurrentsClone = cloneDeep(this.getConcurrentsSelected);
        const clients = (await addManyClients(genererConcurrents(concurrentsClone))).data.result;
        const filesLogos = concurrentsClone.map((el, index) => {
          return { file: getLogoFileFromDataURI(el.urlLogo), id: clients[index].id };
        });
        await this.addPiecesJointe(filesLogos.filter(el => !!el.file));
        this.setLastRayon(this.getRayon);
        this.annuler();
      } catch (error) {
        gestionErreur('Erreur lors de la création des concurrents', error);
        throw error;
      } finally {
        loadingComponent.close();
      }
    },
    dupliquerInfo(value, type, index) {
      this.getConcurrentsSelected.forEach((el, indexValue) => {
        if (indexValue <= index) return;
        switch (type) {
          case ENSEIGNE:
            el[type] = value.enseigne;
            el.enseigneId = value.enseigneId;
            break;
          case ADRESSE:
            el[type] = value.adresse;
            el.adressePostale = value.adressePostale;
            break;
          case SECTEUR_ACTIVITE:
            el.secteurActiviteId = value.secteurActiviteId;
            break;
          default:
            el[type] = value;
            break;
        }
      });
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      const { secteurActiviteId } = this.pointDeVenteRecommandation;
      if (secteurActiviteId) {
        this.getConcurrentsSelected.forEach(pdv => pdv.secteurActiviteId = secteurActiviteId);
      }
    } catch (error) {
      gestionErreur('Erreur interne');
      throw error;
    } finally {
      loadingComponent.close();
    }
  }
};
</script>
